export default __webpack_public_path__ + "static/ProValue_6-1a4066212c1f80950292dfaff74125ae.png";